<template>
  <div class="c-chathams header header--heavy" role="status">
    <h1 :aria-label="$t('org.studyResultsListedBelow')" class="h1">
      {{ $t('org.allStudies') | title }}
      <div class="h3" v-if="count">
        <span v-if="!searchTerm && !location">{{ $t('org.xStudiesFound', { x: count }) }}</span>
        <span v-else>{{ $t('org.xStudiesFoundForY', { x: count, y: countSubject }) }}</span>
        <!-- <span v-if=" !location" role="status" class="visuallyhidden">TEST 3 {{ $t('org.xStudiesFound', { x: count }) }}</span>
      <span v-else role="status" class="visuallyhidden">TEST 4 {{ $t('org.xStudiesFoundForY', { x: count, y: countSubject }) }}</span> -->
      </div>
      <!-- <span role="status" class="visuallyhidden">{{ $t('org.xStudiesFound', { x: count }) }}</span> -->
    </h1>
    <!-- <h2 class="ds-6 my-2" v-if="count">
      <span v-if="!searchTerm && !location">{{ $t('org.xStudiesFound', { x: count }) }}</span>
      <span v-else>{{ $t('org.xStudiesFoundForY', { x: count, y: countSubject }) }}</span>
    </h2>
    <span role="status" class="visuallyhidden">{{ $t('org.xStudiesFound', { x: count }) }}</span> -->
  </div>
</template>

<script>
export default {
  props: {
    count: [Number, String],
    searchTerm: { type: String },
  },
  computed: {
    countSubject() {
      const { location, searchTerm } = this
      return `${searchTerm || ''}${location && searchTerm ? ' - ' : ''}${location || ''}`
    },
    location() {
      return this.$route.query.location
    },
  },
}
</script>
